import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ExcelEditorComponent} from './excel-editor.component';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {HotTableModule} from '@handsontable/angular';



@NgModule({
  declarations: [ExcelEditorComponent],
  exports: [ExcelEditorComponent],
  imports: [
    CommonModule,
    NzTabsModule,
    HotTableModule.forRoot()
  ]
})
export class ExcelEditorModule { }
